<template>
  <div class="user-mgt-page">
    <div class="global-header-wrap">
      <div class="left-part">
        <span v-if="$route.query.id">更新书城广告</span>
        <span v-else>新增书城广告</span>
      </div>
      <div class="right-part">
        <button
          class="global-button-style"
          @click="$router.push({ name: 'advertisement' })"
        >
          {{ $t("commonMsg.back") }}
        </button>
        <button class="global-button-style" @click="save">
          {{ $t("commonMsg.save") }}
        </button>
      </div>
    </div>
    <el-card
      class="app-table-container"
      :body-style="{ padding: '20px' }"
      v-bar
    >
      <div class="body-wrap">
        <el-form
          label-width="100px"
          @submit.native.prevent
          :model="adsInfo"
          ref="ruleForm"
          :rules="rules"
        >
          <el-form-item label="适用型号" prop="pic_address" class="pic">
            <div
              v-for="(item, index) in adsInfo.pic_address"
              :key="index"
              class="pic-item"
            >
              <el-select
                v-model="item.name"
                placeholder="设备型号"
                style="width: 100%"
              >
                <el-option
                  v-for="data in models"
                  :key="data.name"
                  :label="data.name"
                  :value="data.name"
                ></el-option>
              </el-select>
              <div class="ads-edit-cover" @click="imgIdx = index">
                <img v-if="item.addr" :src="item.addr" />
                <i v-else class="ads-edit-cover-icon el-icon-plus"></i>
                <div class="ads-edit-upload">
                  <el-upload
                    class="ads-edit-upload-btn"
                    action
                    :accept="'image/*'"
                    :auto-upload="false"
                    :show-file-list="false"
                    :on-change="handleAvatarChange"
                  >
                    <div v-if="item.addr" class="ads-upload-icon">替换</div>
                  </el-upload>
                </div>
              </div>
            </div>
            <button
              @click="addImgItem"
              class="global-button-style el-icon-plus"
              title="添加广告封面"
            ></button>
          </el-form-item>
          <el-form-item label="广告类型" prop="relate_type">
            <el-select
              v-model="adsInfo.relate_type"
              placeholder="广告类型"
              @change="selectChange"
              style="width: 100%"
            >
              <el-option
                v-for="item in type"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="广告的值" prop="relate_value">
            <div class="overflow">
              <el-select
                v-model="adsInfo.relate_value"
                placeholder="广告的值"
                style="width: 100%"
                v-if="adsInfo.relate_type === 1"
              >
                <el-option
                  v-for="item in type1"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>

              <el-input
                v-model="adsInfo.relate_value"
                style="width: 100%"
                v-if="
                  adsInfo.relate_type === 2 ||
                    adsInfo.relate_type === 5 ||
                    adsInfo.relate_type === 7
                "
                :disabled="
                  adsInfo.relate_type === 5 || adsInfo.relate_type === 7
                "
              ></el-input>

              <el-input
                v-model="adsInfo.relate_value"
                style="width: 100%"
                v-if="adsInfo.relate_type === 4"
                type="number"
              ></el-input>

              <el-select
                v-model="adsInfo.relate_value"
                placeholder="广告的值"
                style="width: 100%"
                v-if="adsInfo.relate_type === 6"
              >
                <el-option
                  v-for="item in bookList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>
          </el-form-item>

          <el-form-item label="发布状态" prop="state">
            <div class="overflow">
              <el-select
                v-model="adsInfo.state"
                placeholder="广告的值"
                style="width: 100%"
              >
                <el-option
                  v-for="item in StateType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { uploadOss } from "@/utils/aliyun";
export default {
  data() {
    return {
      adsInfo: {
        pic_address: [],
        relate_type: 1,
        relate_value: 10000,
        state: 0
      },
      type: [
        {
          value: 1,
          label: "图书广告"
        },
        {
          value: 2,
          label: "外部连接"
        },
        {
          value: 4,
          label: "图书详情页"
        },
        {
          value: 5,
          label: "纯展示"
        },
        {
          value: 6,
          label: "跳到书单"
        },
        {
          value: 7,
          label: "跳到VIP页面"
        }
      ],
      type1: [
        {
          value: 10000,
          label: "默认书单"
        },
        {
          value: 10001,
          label: "推荐书单"
        },
        {
          value: 10002,
          label: "VIP频道"
        },
        {
          value: 10003,
          label: "新书频道"
        },
        {
          value: 10004,
          label: "特价频道"
        },
        {
          value: 10005,
          label: "排行榜"
        }
      ],
      StateType: [
        {
          value: 0,
          label: "未发布"
        },
        {
          value: 1,
          label: "测试"
        },
        {
          value: 2,
          label: "发布"
        },
        {
          value: 3,
          label: "废弃"
        }
      ],
      bookList: [],
      models: [],
      rules: {
        pic_address: [
          { required: true, message: "请选择广告封面", trigger: "change" }
        ],
        relate_type: [
          { required: true, message: "请选择广告类型", trigger: "change" }
        ]
      },
      imgIdx: 0
    };
  },
  methods: {
    selectChange(val) {
      const actions = {
        val_1: () => (this.adsInfo.relate_value = 10000),
        val_6: async () => {
          let res = await this.$http.getBookList();
          this.bookList = res.data.rows;
          this.adsInfo.relate_value = this.bookList[0].id;
        },
        val_7: () =>
          (this.adsInfo.relate_value =
            "http://dev.onyx-international.cn/pay.html"),
        val_default: () => (this.adsInfo.relate_value = "")
      };

      let action = actions[`val_${val}`] || actions["val_default"];
      action();
    },
    addImgItem() {
      this.adsInfo.pic_address.push(Object.assign({}, this.models[0]));
    },
    async handleAvatarChange(file, filtList) {
      let cover = await uploadOss(file);
      this.adsInfo.pic_address[this.imgIdx].addr = cover;
      // this.adsInfo.pic_address[this.imgIdx].addr = URL.createObjectURL(file.raw)
    },

    save() {
      for (let cover of this.adsInfo.pic_address) {
        if (!cover.addr) {
          this.elMsg("广告封面不能为空", "error");
          return;
        }
      }
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          for (let i of this.adsInfo.pic_address) {
            for (let j of this.models) {
              if (i.name === j.name) {
                i.model = j.model;
              }
            }
          }
          this.$route.query.id ? this.editAds() : this.createAds();
        } else {
          return false;
        }
      });
    },

    getAdsDetails() {
      this.$http.getAdsDetails(this.$route.query.id).then(async res => {
        if (res.data.relate_type === 6) {
          let res = await this.$http.getBookList();
          this.bookList = res.data.rows;
        }

        ({
          state: this.adsInfo.state,
          relate_type: this.adsInfo.relate_type,
          pic_address: this.adsInfo.pic_address
        } = res.data);
        this.adsInfo.relate_value = this.filterRelateValue(
          res.data.relate_type,
          res.data
        );
      });
    },

    filterRelateValue(type, data) {
      const actions = new Map([
        ["get_1", () => data.channel_id],
        ["get_2", () => data.relate_link],
        ["get_4", () => data.ebook_id],
        ["get_5", () => ""],
        ["get_6", () => Number(data.module_id)],
        ["get_7", () => data.vip_link]
      ]);

      let action = actions.get(`get_${type}`);
      return action();
    },

    getBookList() {
      return this.$http.getBookList();
    },

    createAds() {
      this.$http.createAds(this.adsInfo).then(res => {
        this.elMsg(this.$t("alertMsg.saveSuccess"), "success");
        this.$router.push({ name: "advertisement" });
      });
    },

    editAds() {
      this.$http.editAds(this.$route.query.id, this.adsInfo).then(res => {
        this.$router.push({ name: "advertisement" });
        this.elMsg(this.$t("alertMsg.editSuccess"), "success");
      });
    },

    getModelGroups() {
      return new Promise(async (resolve, reject) => {
        let res = await this.$http.getModelGroups({
          sortBy: "updatedAt",
          limit: 100000
        });
        for (let item of res.data.results) {
          this.models = [
            ...this.models,
            { name: item.name, addr: "", model: item.models.join(",") }
          ];
        }
        resolve("ok");
      });
    }

    // setTreeNode(data) {
    //   let obj = {};
    //   for (let item of data) {
    //     if (Object.keys(obj).includes(item.size)) {
    //       obj[item.size].model += `,${item.model}`;
    //     } else {
    //       obj[item.size] = {
    //         size: item.size,
    //         model: item.model,
    //         addr: ""
    //       };
    //     }
    //   }
    //   return Object.values(obj);
    // }
  },
  async mounted() {
    await this.getModelGroups();
    if (this.$route.query.id) {
      this.getAdsDetails();
    } else {
      this.adsInfo.pic_address.push(Object.assign({}, this.models[0]));
    }
  }
};
</script>

<style lang="scss">
.user-mgt-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .body-wrap {
    /* height: 100%; */
    flex: 1;
    overflow: hidden;
    .el-form {
      width: 90%;
      .global-button-style {
        width: 100%;
        margin: 0;
      }
    }
    .pic {
      .pic-item {
        /* position: relative; */
        display: flex;
        flex-direction: column;
        overflow: hidden;
      }
      .global-button-style {
        width: 80px;
        height: 30px;
      }
      .ads-edit-cover {
        position: relative;
        width: 400px;
        height: 150px;
        overflow: hidden;
        margin: 10px 0;
        border: 2px dashed #ccc;
        border-radius: 10px;
        &:hover {
          border-color: #bb745c;
        }
        > img {
          width: 100%;
          height: 100%;
        }
        > .ads-edit-cover-icon {
          font-weight: bold;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          color: #bb745c;
        }
        > .ads-edit-upload {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          transition: all 0.2s;
          &:hover {
            transition: all 0.2s;
            background: rgba($color: #000000, $alpha: 0.4);
            .ads-edit-upload-btn {
              display: block;
            }
          }
          .ads-edit-upload-btn {
            width: 100%;
            height: 100%;
            display: none;
            cursor: pointer;
            color: #fff;
            font-weight: bold;
            position: absolute;
            text-align: center;
            line-height: 150px;
            > .el-upload--text {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
      .add-img {
        width: 70px;
        height: 40px;
        font-size: 22px;
        line-height: 43px;
        color: #fff;
        cursor: pointer;
        background-color: #bb745c;
      }
    }
  }
}
</style>
